import styled from "styled-components";
import Popup from 'reactjs-popup';

export const StyledPopup = styled(Popup)`
  &-content {
    z-index: 10000 !important;
    & div {
        border-radius: 0px !important;
    }
  }
`;

export const BodyCard = styled.div`
text-align: left;
padding-right: 15px;
margin-top: 5px;
margin-bottom: 1.5em;
margin-right: 10px;
`

export const HeadCard = styled.div<any>`
  display: flex;
  justify-content: space-between;
  margin-top: .5em;
  margin-bottom: 1.5em;
  & p {
    margin: 0px;
  }
  
`

export const BottomCard = styled.div`
display: flex;
justify-content: flex-start;
margin-top: 1em;
margin-right: 10px;
`
export const TitleLocalization = styled.div`
    padding-left: 10px;
`